import React from "react";
import { AlertsProvider } from "contexts/alert";
import { ToastNotifyProvider } from "./notifyToast";

export const AppProvider: React.FC = ({ children }) => (
    <ToastNotifyProvider>
        <AlertsProvider>{children}</AlertsProvider>
    </ToastNotifyProvider>
);
